import { AppConfigService } from './appconfig.service';
//import { Logger } from './log.service';
import { UserService } from './user.service';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
const services: any[] = [
  AppConfigService,
  //Logger,
  UserService,
  AuthGuard,
  AuthService,
];

export default { services };